module.exports = __webpack_public_path__ + "static/media/Aesir1.42cf38e3.png";